import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

// Compteurs d'actions du menu : rechargés à chaque navigation, après toute mutation API (événement) et toutes les 60 s.
export function useNavCounters(enabled) {
  const [c, setC] = useState({});
  const loc = useLocation();
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    const load = () => api.get("/nav/counters").then((r) => alive && setC(r.data)).catch(() => {});
    load();
    window.addEventListener("sanitdocs:refresh-counters", load);
    const t = setInterval(() => document.visibilityState === "visible" && load(), 60000);
    return () => { alive = false; clearInterval(t); window.removeEventListener("sanitdocs:refresh-counters", load); };
  }, [enabled, loc.pathname]);
  return c;
}

// Badge d'ACTIONS à traiter (distinct de la cloche = notifications). Rien à 0.
export function NavBadge({ n, testid, mobile = false, dark = false }) {
  if (!n) return null;
  const txt = n > 99 ? "99+" : n;
  if (mobile) return <span data-testid={testid} className="absolute -top-1.5 -right-2.5 min-w-[17px] h-[17px] px-1 rounded-full bg-accent-600 text-white text-[10px] font-bold leading-[17px] text-center ring-2 ring-white pointer-events-none">{txt}</span>;
  return <span data-testid={testid} className={`ml-auto min-w-[20px] h-5 px-1.5 rounded-full text-[11px] font-bold leading-5 text-center ${dark ? "bg-accent-100 text-accent-800" : "bg-white/15 text-white"}`}>{txt}</span>;
}
